import bus from "../../admin-bus";
import { MODAL_CLOSE, MODAL_UPDATE } from "../../action-types";

/**
 * Provides form behaviour for forms rendered in modals
 * @param  {Node} el Element
 * @return {Void}
 */

export default function modalForm(el) {
  const cancelButton = el.querySelector(".cancel-button");

  function handleSubmit(e) {
    e.preventDefault();

    const formData = new FormData(el);

    window
      .fetch(el.getAttribute("action"), {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        },
        method: "POST",
        body: formData
      })
      .then(onFetchComplete)
      .catch(error => {
        console.log("Request failed: ", error);
      });
  }

  function onFetchComplete(response) {
    response.text().then(data => {
      bus.emit(MODAL_UPDATE, { content: data });
    });
  }

  function handleCancelButtonClick(e) {
    e.preventDefault();
    bus.emit(MODAL_CLOSE);
  }

  el.addEventListener("postserialization", handleSubmit);
  cancelButton.addEventListener("click", handleCancelButtonClick);
}
